import { defineComponent, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
export default defineComponent({
  name: 'ExamInfoModal',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup: function (props) {
    var loading = ref(false);
    var router = useRouter();
    var route = useRoute();
    var onStartExamButtonClick = function () {
      router.push({
        name: 'Examination',
        params: {
          id: props.data.userExamId
        },
        query: {
          platform: String(route.meta.platform || '')
        }
      });
    };
    var onClose = function () {
      props.data.visible = false;
    };
    var isAildContest = computed(function () {
      return route.meta.platform === 'aild';
    });
    return {
      loading: loading,
      onStartExamButtonClick: onStartExamButtonClick,
      onClose: onClose,
      isAildContest: isAildContest
    };
  }
});